import React from 'react';
import { useForm } from 'react-hook-form';
import Button from 'atomic/utilization/button';

import './make-report-form.scss';

interface MakeCommentFormProps {
    onSubmit: (data: { bugName: string[]; }) => void;
}

interface MakeCommentFormFieldsInterface {
    id: string;
    name: string;
    value: string;
}

const MakeReportForm: React.FC<MakeCommentFormProps> = ({ onSubmit }) => {
    const checkboxFields: MakeCommentFormFieldsInterface[] = [
        {
            id: 'other-price',
            name: 'bugName[]',
            value: 'Inna cena'
        },
        {
            id: 'other-product',
            name: 'bugName[]',
            value: 'Inny produkt'
        },
        {
            id: 'product-unavailable',
            name: 'bugName[]',
            value: 'Produkt niedostępny'
        },
        {
            id: 'different-shipping-cost',
            name: 'bugName[]',
            value: 'Inny koszt dostawy'
        },
        {
            id: 'different-availability',
            name: 'bugName[]',
            value: 'Inna dostępność'
        }
    ];
    const { register, watch, handleSubmit, formState } = useForm({ mode: 'onChange' });
    const validate = (): boolean => watch('bugName')?.length > 0;

    return (
        <form onSubmit={handleSubmit(onSubmit as unknown as any)} className="make-report-form">
            <div className="make-report-form__content">
                {
                    checkboxFields.map(item => (
                        <div className="make-report-form__content__group" key={item.id}>
                            <input
                                key={item.value}
                                /* eslint-disable react/jsx-props-no-spreading */
                                {...register(item.name, { required: false, validate })}
                                id={item.id}
                                type="checkbox"
                                value={item.value}
                                aria-label={item.value}
                            />
                            <label htmlFor={item.id} className="form-check-label">
                                {item.value}
                            </label>
                        </div>
                    ))
                }
            </div>
            <Button disabled={!formState.isValid} type="submit" color="blue"
                weight="600" block={true} uppercase={true}
            >
                Wyślij
            </Button>
        </form>
    );
};

export default MakeReportForm;
